export const LineClamp: Record<number, string> = {
  [1]: 'e-line-clamp-1',
  [2]: 'e-line-clamp-2',
  [3]: 'e-line-clamp-3',
  [4]: 'e-line-clamp-4',
  [5]: 'e-line-clamp-5',
  [6]: 'e-line-clamp-6',
  [15]: 'e-line-clamp-15',
};
